import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AppStore } from './app.store';
import { MatIconRegistry } from '@angular/material/icon';
import { CUSTOM_ICONS } from './app.const';
import { DomSanitizer } from '@angular/platform-browser';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatProgressSpinnerModule],
  templateUrl: './app.component.html'
})
export class AppComponent {
  appStore = inject(AppStore);
  router = inject(Router);
  matIconRegistry = inject(MatIconRegistry);
  domSanitizer = inject(DomSanitizer);
  appService = inject(AppService);

  constructor() {
    CUSTOM_ICONS.forEach((iconName) => {
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`icons/${iconName}.svg`)
      );
    });
  }
}
